import {
  ActionIcon,
  Box,
  Button,
  Center,
  Group,
  LoadingOverlay,
  Modal,
  Paper,
  Progress,
  Stack,
  Text,
  ThemeIcon,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconAddressBook,
  IconAlertTriangle,
  IconArrowRight,
  IconChevronDown,
  IconCircleArrowRight,
  IconHeadset,
  IconLoader,
  IconRefreshDot,
  IconRocket,
  IconRouteSquare2,
  IconUser,
} from "@tabler/icons-react";
import cover_fr from "../../../assets/cover_fr.jpg";
import cover_en from "../../../assets/cover_en.jpg";
import { useCallback, useEffect, useMemo, useState } from "react";
import { IconLinkedin } from "../../../components/Icons/IconLinkedin";
import { useLanguage } from "../../../stores/LanguageStore";
import { useProfileStore, useSessionStore } from "../../../stores/UserStore";
import { useListStore } from "../../../stores/ListStore";
import { useAccountsStore, useModelsStore } from "../../../stores/ConfigStore";
import { getLists, getListsQuick } from "../../../api/ContactAPI";
import { getMEmails } from "../../../api/ModelsApi";
import { useReportingStore } from "../../../stores/ReportingStore";
import { Link } from "react-router-dom";
import IconCheckmark from "../../../assets/icons/IconCheckmark";
import { IconEmail } from "../../../assets/icons/IconEmail";
import IconWhiteLabel from "../../../assets/icons/IconWhiteLabel";
import {
  CalendarStarIcon,
  KeyIcon,
  LinkIcon,
  PlayIcon,
  QuestionIcon,
} from "../../../components/Icons/SvgIcons";
import def_cover from "../../../assets/onboarding/0-def.png";
import email_cover from "../../../assets/onboarding/1-Pic Onboarding_email Exp.png";
import linkedin_cover from "../../../assets/onboarding/2-Onboarding_linkedin.png";
import contacts_cover from "../../../assets/onboarding/3-Onboarding_créa liste.png";
import model_cover from "../../../assets/onboarding/4-Onboarding_Créa modèle.png";
import campaign_cover from "../../../assets/onboarding/5-Onboarding_créa première campagne.png";
import VideoModalViewer from "../../../components/View/VideoModalViewer";

import cover_digital_agency from "../../../assets/COVER-DIGITAL-AGENCY.jpg";
import CompleteProfile from "./CompleteProfile";
import { getEmbedUrl } from "../../../functions/utilFunctions";
import Locked from "../../../components/View/Locked";

// const JoyrideComponent = ({
//   index,
//   step,
//   isLastStep,
//   size,
//   closeProps,
//   skipProps,
//   primaryProps,
//   tooltipProps,
// }) => {
//   return (
//     <Paper {...tooltipProps} p={"md"}>
//       <Stack>{step.content}</Stack>
//     </Paper>
//   );
// };

const DefaultContent = ({ active, setActive }) => {
  const lang = useLanguage((s) => s.language);
  const video = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeWelcomeDemo")?.url;
  const thumbnail_url = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeWelcomeDemo")?.thumbnail_url;

  if (active !== "def") {
    return;
  }
  return (
    <Paper
      className="animate__animated animate__fadeInRight animate__faster "
      component={Stack}
      // justify="center"
      w={500}
      mx={"auto"}
      style={{
        borderRadius: 32,
      }}
      mt={16}
      bg={"transparent"}
    >
      <Title order={4} fw={500} ta={"left"}>
        {lang.home.get_started.default.title.replace(
          "$",
          useSessionStore.getState().reseller?.name
        )}
      </Title>
      {useSessionStore.getState().reseller.name === "Magileads" || (thumbnail_url && video) ? (
        <VideoModalViewer
          src={video || "https://www.youtube.com/embed/qzZkcmTB5I0?si=pK-7oX7lxJcjifch"}
          opener={(handleOpen) => (
            <Box pos={"relative"} className="cover" onClick={handleOpen}>
              <PlayIcon
                variant="light"
                color={thumbnail_url ? "var(--mantine-color-primary-5)" : "#fcfbff"}
                size={128}
                iconSize={64}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 10,
                }}
                radius={64}
                className="play-button"
              />
              <img
                src={thumbnail_url || (lang.id === "FRA" ? cover_fr : cover_en)}
                style={{
                  width: "100%",
                  boxShadow: "#00000016 0 2px 6px",
                  borderRadius: 24,
                }}
              />
            </Box>
          )}
        />
      ) : video ? (
        video.includes("youtube") ? (
          <iframe
            src={getEmbedUrl(video)}
            width="100%"
            height="250"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowfullscreen
            frameBorder={0}
            style={{
              borderRadius: 8,
            }}
          ></iframe>
        ) : (
          <video src={video} controls className="reseller-video" />
        )
      ) : (
        <img
          src={
            useSessionStore.getState()?.reseller?.name === "Digital Agency"
              ? cover_digital_agency
              : def_cover
          }
          style={
            useSessionStore.getState()?.reseller?.name === "Digital Agency"
              ? { objectFit: "cover", borderRadius: 16, overflow: "hidden" }
              : {}
          }
          height={
            useSessionStore.getState()?.reseller?.name === "Digital Agency"
              ? 270
              : 290
          }
        />
      )}

      <Group justify="center" mt={16}>
        <Button
          size="lg"
          radius={"md"}
          w={350}
          fz={18}
          leftSection={<IconCircleArrowRight size={28} />}
          onClick={() => setActive("email")}
          variant="outline"
          style={{
            borderColor: "#f2eaff",
          }}
        >
          {lang.home.get_started.default.button_label}
        </Button>
      </Group>
    </Paper>
  );
};

const ProfileContent = ({ active, onFinish }) => {
  if (active !== "profile") {
    return;
  }
  return (
    <Paper
      className="profile-section section  animate__animated animate__fadeInRight animate__faster"
      px={64}
      w={"100%"}
    >
      <CompleteProfile onFinish={onFinish} />
    </Paper>
  );
};

const EmailContent = ({ active, isInvalid }) => {
  const lang = useLanguage((s) => s.language);
  const [launch, setLaunch] = useState(false);
  const [index, setIndex] = useState(0);
  const video = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "HomeSenderEmailConnectDemo"
    )?.url;
  const thumbnail_url = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeSenderEmailConnectDemo")?.thumbnail_url;

  // const steps = useMemo(() => {
  //   const ressourcesOpened = useUIStore.getState().campaignOpened;
  //   let newSteps = [];

  //   if (!ressourcesOpened) {
  //     newSteps.push({
  //       target: "#nav-ressources",
  //       content: <Text>Ouvrez ressources</Text>,
  //       placement: "right",
  //       disableBeacon: true, // To autostart the tour
  //       needClick: true,
  //       clickDelay: 400,
  //     });
  //   }
  //   newSteps.push(
  //     {
  //       target: "#senders",
  //       content: <Text>Cliquez sur Expéditeurs</Text>,
  //       placement: "right",
  //       disableBeacon: true, // To autostart the tour
  //       needClick: true,
  //       clickDelay: 400,
  //     },
  //     {
  //       target: "#email-senders",
  //       content: (
  //         <Text>
  //           Naviguez sur la page des Expéditeurs Emails en cliquant ici
  //         </Text>
  //       ),
  //       placement: "right",
  //     }
  //   );

  //   return newSteps;
  // }, []);

  // const handleTour = (data) => {
  //   function next() {
  //     setIndex(data.index + 1);
  //   }

  //   if (data.action === "skip") {
  //     next();
  //   }
  //   if (
  //     (data.type === "tour:end" && data.action !== "skip") ||
  //     data.action === "close"
  //   ) {
  //     setIndex(0);
  //   }

  //   if (data.step.needClick) {
  //     return document.querySelector(data.step.target)?.addEventListener(
  //       "click",
  //       (e) => {
  //         setTimeout(() => {
  //           next();
  //         }, data.step.clickDelay);
  //       },
  //       { once: true }
  //     );
  //   }

  //   if (data.action === "next" && data.type === "step:after") {
  //     next();
  //   }
  // };

  if (active !== "email") {
    return;
  }
  if (isInvalid) {
    return (
      <Paper
        className="email-section section  animate__animated animate__fadeInRight animate__faster"
        px={64}
      >
        {useSessionStore.getState().reseller.name === "Magileads" ? (
          <iframe
            src={
              "https://app.supademo.com/embed/cm518ffzl1q4bvlry46o0760i?embed_v=2"
            }
            loading="lazy"
            title={"Demo email"}
            allow="clipboard-write"
            webkitallowFullScreen="true"
            mozallowFullScreen="true"
            allowfullscreen
            style={{
              position: "relative",
              width: "100%",
              height: 275,
              border: 0,
            }}
          ></iframe>
        ) : (
          <img src={thumbnail_url || email_cover} alt="email-cover" />
        )}
        <Text>{lang.home.get_started.email.title_reconnect}</Text>
        <Text fw={400}>
          {lang.home.get_started.email.text1_reconnect} <br /> <br />
          {lang.home.get_started.email.text2_reconnect}
          <Tooltip label={lang.home.get_started.email.button_tooltip_reconnect}>
            <ActionIcon
              size="lg"
              color="green"
              radius={64}
              display={"inline"}
              ml={16}
              style={{ verticalAlign: "middle" }}
            >
              <IconRefreshDot size={20} />
            </ActionIcon>
          </Tooltip>
        </Text>

        <Group justify="center" mt={8}>
          <Button
            size="md"
            variant="filled"
            rightSection={<IconEmail />}
            filled={{ from: "#ffd427", to: "#f6b033" }}
            radius={"md"}
            component={Link}
            to={"/senders/email"}
          // onClick={() => {
          //   setLaunch(true);
          // }}
          >
            {lang.home.get_started.email.button_label_reconnect}
          </Button>
        </Group>
      </Paper>
    );
  }
  return (
    <>
      <Paper
        className="email-section section  animate__animated animate__fadeInRight animate__faster"
        px={64}
      >
        {useSessionStore.getState().reseller.name === "Magileads" ? (
          <iframe
            src={
              "https://app.supademo.com/embed/cm518ffzl1q4bvlry46o0760i?embed_v=2"
            }
            loading="lazy"
            title={
              "https://app.supademo.com/embed/cm518ffzl1q4bvlry46o0760i?embed_v=2"
            }
            allow="clipboard-write"
            webkitallowFullScreen="true"
            mozallowFullScreen="true"
            allowfullscreen
            style={{
              position: "relative",
              width: "100%",
              height: 275,
              border: 0,
            }}
          ></iframe>
        ) : video ? (
          video.includes("youtube") ? (
            <Center>
              <iframe
                src={getEmbedUrl(video)}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowfullscreen
                className="reseller-video"
                frameBorder={0}
                style={{
                  height: 275,
                  width: 480,
                }}
              ></iframe>
            </Center>
          ) : (
            <Center>
              <video
                src={video}
                controls
                className="reseller-video"
                style={{
                  height: 275,
                  width: "auto",
                  display: "block",
                }}
              />
            </Center>
          )
        ) : (
          <img src={email_cover} alt="email-cover" />
        )}
        <Text fw={400} mt={8}>
          {lang.home.get_started.email.text1.replace(
            "Magileads",
            useSessionStore.getState().reseller?.name
          )}
          <br />
          {lang.home.get_started.email.text2.replace(
            "Magileads",
            useSessionStore.getState().reseller?.name
          )}
        </Text>
        <Text fw={700}>
          {lang.home.get_started.email.text3.replace(
            "Magileads",
            useSessionStore.getState().reseller?.name
          )}
        </Text>

        <Group justify="center" mt={8}>
          <Button
            size="md"
            rightSection={<LinkIcon color="#fcfbff" />}
            filled={{ from: "#ffd427", to: "#f6b033" }}
            radius={"md"}
            component={Link}
            to={"/senders/email"}
            // onClick={() => {
            //   setLaunch(true);
            // }}
            variant="subtle"
            leftSection={<IconArrowRight size={20} />}
          >
            {lang.home.get_started.email.button_label}
          </Button>
        </Group>
      </Paper>

      {/* <ReactJoyride
        steps={steps}
        continuous
        run={launch}
        stepIndex={index}
        callback={handleTour}
        styles={{
          options: {
            zIndex: 9999,
            width: "auto",
            primaryColor:
              "#" + useSessionStore?.getState()?.reseller?.color_secondary,
          },
          tooltipContent: {
            textAlign: "left",
          },
          buttonNext: {
            fontSize: 14,
            marginLeft: 16,
          },
          buttonClose: {
            fontSize: 14,
          },
          buttonSkip: {
            fontSize: 14,
          },
          buttonBack: {
            fontSize: 14,
          },
        }}
        locale={{
          next: lang.tours.next,
          back: lang.tours.prev,
          skip: lang.tours.skip,
          close: lang.tours.close,
          open: lang.tours.open,
          last: lang.tours.last,
        }}
        disableOverlayClose
        disableScrolling
        spotlightClicks
        hideBackButton
        hideCloseButton
        spotlightPadding={1}
        tooltipComponent={JoyrideComponent}
      /> */}
    </>
  );
};

const LinkedinContent = ({ active }) => {
  const lang = useLanguage((s) => s.language);
  const video = useSessionStore
    .getState()
    .reseller?.videos?.find(
      (x) => x.name === "HomeLinkedinAccountConnectDemo"
    )?.url;
  const thumbnail_url = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeLinkedinAccountConnectDemo")?.thumbnail_url;

  if (active !== "linkedin") {
    return;
  }
  return (
    <Paper
      className="linkedin-section  section  animate__animated animate__fadeInRight animate__faster"
      px={64}
    >
      {useSessionStore.getState().reseller.name === "Magileads" ? (
        <iframe
          src={
            "https://app.supademo.com/embed/cm5198y810x2wpeaqueawl0ow?embed_v=2"
          }
          loading="lazy"
          title={"Linkedin demo"}
          allow="clipboard-write"
          webkitallowFullScreen="true"
          mozallowFullScreen="true"
          allowfullscreen
          style={{
            position: "relative",
            width: "100%",
            height: 275,
            border: 0,
          }}
        ></iframe>
      ) : video ? (
        video.includes("youtube") ? (
          <Center>
            <iframe
              src={getEmbedUrl(video)}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="reseller-video"
              frameBorder={0}
              style={{
                height: 275,
                width: 480,
              }}
            ></iframe>
          </Center>
        ) : (
          <Center>
            <video
              src={video}
              controls
              className="reseller-video"
              style={{
                height: 275,
                width: "auto",
                display: "block",
              }}
            />
          </Center>
        )
      ) : (
        <img src={thumbnail_url || linkedin_cover} alt="linkedin-cover" />
      )}
      <Text fw={400} mt={8}>
        {lang.home.get_started.linkedin.text1.replaceAll(
          "Magileads",
          useSessionStore.getState().reseller?.name
        )}
      </Text>
      <Text fw={700}>
        {lang.home.get_started.linkedin.text2.replaceAll(
          "Magileads",
          useSessionStore.getState().reseller?.name
        )}
      </Text>

      <Group justify="center" mt={8}>
        <Button
          size="md"
          filled={{ from: "#4a979b", to: "#4e67ae" }}
          radius={"md"}
          component={Link}
          to={"/senders/linkedin"}
          onClick={() => {
            return useSessionStore.getState()?.reseller?.name === "Magileads"
              ? window.open(
                "https://chromewebstore.google.com/detail/magileads-v2/oojfjkpfkaekaifokifpgfaghiokinaf"
              )
              : null;
          }}
          variant="subtle"
          leftSection={<IconArrowRight size={20} />}
        >
          {lang.home.get_started.linkedin.button_label}
        </Button>
      </Group>
    </Paper>
  );
};

const ContactsContent = ({ active }) => {
  const lang = useLanguage((s) => s.language);
  const video = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeListCreationDemo")?.url;
  const thumbnail_url = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeListCreationDemo")?.thumbnail_url;

  if (active !== "contacts") {
    return;
  }
  return (
    <Paper
      className="contacts-section  section  animate__animated animate__fadeInRight animate__faster"
      px={64}
    >
      {useSessionStore.getState().reseller.name === "Magileads" ? (
        <iframe
          src={
            "https://app.supademo.com/embed/cm51abswc1rolvlry6fh8tjp4?embed_v=2"
          }
          loading="lazy"
          title={"Demo contacts"}
          allow="clipboard-write"
          webkitallowFullScreen="true"
          mozallowFullScreen="true"
          allowfullscreen
          style={{
            position: "relative",
            width: "100%",
            height: 275,
            border: 0,
          }}
        ></iframe>
      ) : video ? (
        video.includes("youtube") ? (
          <Center>
            <iframe
              src={getEmbedUrl(video)}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="reseller-video"
              frameBorder={0}
              style={{
                height: 275,
                width: 480,
              }}
            ></iframe>
          </Center>
        ) : (
          <Center>
            <video
              src={video}
              controls
              className="reseller-video"
              style={{
                height: 275,
                width: "auto",
                display: "block",
              }}
            />
          </Center>
        )
      ) : (
        <img src={thumbnail_url || contacts_cover} alt="contacts-cover" />
      )}
      <Text fw={400} mt={8}>
        {lang.home.get_started.contacts.text1.replace(
          "Magileads",
          useSessionStore.getState().reseller?.name
        )}
        <br />{" "}
        {lang.home.get_started.contacts.text2.replace(
          "Magileads",
          useSessionStore.getState().reseller?.name
        )}
      </Text>
      <Group justify="center" mt={8}>
        <Button
          size="md"
          variant="subtle"
          leftSection={<IconArrowRight size={20} />}
          radius={"md"}
          component={Link}
          to={"/contact-lists/import"}
        >
          {lang.home.get_started.contacts.button_label}
        </Button>
      </Group>
    </Paper>
  );
};

const ModelsContent = ({ active }) => {
  const lang = useLanguage((s) => s.language);
  const video = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeTemplateCreationDemo")?.url;
  const thumbnail_url = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeTemplateCreationDemo")?.thumbnail_url;


  if (active !== "models") {
    return;
  }
  return (
    <Paper
      className="models-section  section  animate__animated animate__fadeInRight animate__faster"
      px={64}
    >
      {useSessionStore.getState().reseller.name === "Magileads" ? (
        <iframe
          src={
            "https://app.supademo.com/embed/cm51an3gu1rywvlryljpxx7ew?embed_v=2"
          }
          loading="lazy"
          title={"Demo models"}
          allow="clipboard-write"
          webkitallowFullScreen="true"
          mozallowFullScreen="true"
          allowfullscreen
          style={{
            position: "relative",
            width: "100%",
            height: 275,
            border: 0,
          }}
        ></iframe>
      ) : video ? (
        video.includes("youtube") ? (
          <Center>
            <iframe
              src={getEmbedUrl(video)}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="reseller-video"
              frameBorder={0}
              style={{
                height: 275,
                width: 480,
              }}
            ></iframe>
          </Center>
        ) : (
          <Center>
            <video
              src={video}
              controls
              className="reseller-video"
              style={{
                height: 275,
                width: "auto",
                display: "block",
              }}
            />
          </Center>
        )
      ) : (
        <img src={thumbnail_url || model_cover} alt="model-cover" />
      )}
      <Text fw={400} mt={8}>
        {lang.home.get_started.models.text1.replace(
          "Magileads",
          useSessionStore.getState().reseller?.name
        )}
      </Text>
      <Group justify="center" mt={8}>
        <Button
          size="md"
          variant="subtle"
          leftSection={<IconArrowRight />}
          filled={{ from: "#4a979b", to: "#4e67ae" }}
          radius={"md"}
          component={Link}
          to={"/models/email"}
        >
          {lang.home.get_started.models.button_label}
        </Button>
      </Group>
    </Paper>
  );
};

const CampaignContent = ({ active }) => {
  const lang = useLanguage((s) => s.language);
  const video = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeCampaignCreationDemo")?.url;
  const thumbnail_url = useSessionStore
    .getState()
    .reseller?.videos?.find((x) => x.name === "HomeCampaignCreationDemo")?.thumbnail_url;


  if (active !== "campaign") {
    return;
  }
  return (
    <Paper
      className="campaign-section  section  animate__animated animate__fadeInRight animate__faster"
      px={64}
    >
      {useSessionStore.getState().reseller.name === "Magileads" ? (
        <iframe
          src={
            "https://app.supademo.com/embed/cm51b6w3e0xwcpeaq38apqwc8?embed_v=2"
          }
          loading="lazy"
          title={"Demo campaign"}
          allow="clipboard-write"
          webkitallowFullScreen="true"
          mozallowFullScreen="true"
          allowfullscreen
          style={{
            position: "relative",
            width: "100%",
            height: 275,
            border: 0,
          }}
        ></iframe>
      ) : video ? (
        video.includes("youtube") ? (
          <Center>
            <iframe
              src={getEmbedUrl(video)}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowfullscreen
              className="reseller-video"
              frameBorder={0}
              style={{
                height: 275,
                width: 480,
              }}
            ></iframe>
          </Center>
        ) : (
          <Center>
            <video
              src={video}
              controls
              className="reseller-video"
              style={{
                height: 275,
                width: "auto",
                display: "block",
              }}
            />
          </Center>
        )
      ) : (
        <img src={thumbnail_url || campaign_cover} alt="campaign-cover" height={300} />
      )}
      <Text fw={400} mt={8}>
        {lang.home.get_started.campaign.text1.replace(
          "Magileads",
          useSessionStore.getState().reseller?.name
        )}
      </Text>
      <Group justify="center" mt={8}>
        <Button
          size="md"
          filled={{ from: "#ffd427", to: "#f6b033" }}
          radius={"md"}
          component={Link}
          to={"/campaign/create"}
          variant="subtle"
          leftSection={<IconArrowRight />}
        >
          {lang.home.get_started.campaign.button_label}
        </Button>
      </Group>
    </Paper>
  );
};

const iconProps = {};

const GetStarted = () => {
  const lang = useLanguage((s) => s.language);
  const [active, setActive] = useState("def");
  const [openedVideo, setOpenedVideo] = useState(false);

  const [elements, setElements] = useState({
    def: {
      done: false,
      label: "",
      icon: <IconEmail {...iconProps} />,
    },
    profile: {
      done: false,
      invalid: false,
      label: lang.profile.onboarding_step,
      icon: <IconUser {...iconProps} />,
    },
    email: {
      done: false,
      invalid: false,
      label: lang.home.get_started.email.label,
      icon: <IconEmail {...iconProps} />,
    },
    linkedin: {
      done: false,
      invalid: false,
      label: lang.home.get_started.linkedin.label,
      icon: <IconLinkedin {...iconProps} />,
    },
    contacts: {
      done: false,
      label: lang.home.get_started.contacts.label,
      icon: <IconAddressBook {...iconProps} />,
    },
    models: {
      done: false,
      label: lang.home.get_started.models.label,
      icon: <IconRouteSquare2 {...iconProps} />,
    },
    campaign: {
      done: false,
      label: lang.home.get_started.campaign.label,
      icon: <IconRocket {...iconProps} />,
    },
  });

  const [loading, setLoading] = useState(true);
  const profile = useProfileStore((s) => s.profile);
  const email_accounts = useAccountsStore((s) => s.email_accounts);
  const linkedin_accounts = useAccountsStore((s) => s.linkedin_accounts);
  const model_emails = useModelsStore((s) => s.model_emails);
  const lists = useListStore((s) => s.lists);
  const global_stats = useReportingStore((s) => s.globalStats);

  useEffect(() => {
    async function main() {
      if (lists.length === 0) {
        await getListsQuick();
      }
      if (model_emails.length === 0) {
        await getMEmails();
      }
      setLoading(false);
    }

    if (loading) {
      main();
    }
  }, [lists, loading, model_emails]);

  useEffect(() => {
    if (!loading) {
      let newElements = {
        def: {
          done: false,
          label: "",
          icon: <IconEmail {...iconProps} />,
        },
        profile: {
          done: false,
          label: lang.profile.onboarding_step,
          icon: <IconUser {...iconProps} />,
        },
        email: {
          done: false,
          invalid: false,
          label: lang.home.get_started.email.label,
          icon: <IconEmail {...iconProps} />,
        },
        linkedin: {
          done: false,
          invalid: false,
          label: lang.home.get_started.linkedin.label,
          icon: <IconLinkedin {...iconProps} />,
        },
        contacts: {
          done: false,
          label: lang.home.get_started.contacts.label,
          icon: <IconAddressBook {...iconProps} />,
        },
        models: {
          done: false,
          label: lang.home.get_started.models.label,
          icon: <IconRouteSquare2 {...iconProps} />,
        },
        campaign: {
          done: false,
          label: lang.home.get_started.campaign.label,
          icon: <IconRocket {...iconProps} />,
        },
      };

      // Profile
      if (!profile?.company || !profile?.mobile_phone || !profile?.job_title) {
        newElements = {
          ...newElements,
          profile: {
            ...newElements.profile,
            done: false,
            invalid: true,
          },
        };
      } else {
        newElements = {
          ...newElements,
          profile: {
            ...newElements.profile,
            done: true,
            invalid: false,
          },
        };
      }
      if (profile?.company && profile?.mobile_phone && profile?.job_title) {
        delete newElements.profile;
      }

      // Emails
      if (email_accounts.length === 0) {
        newElements = {
          ...newElements,
          email: {
            ...newElements.email,
            done: false,
          },
        };
      } else {
        newElements = {
          ...newElements,
          email: {
            ...newElements.email,
            done: true,
            invalid: email_accounts?.filter((x) => x.is_valid)?.length === 0,
          },
        };
      }

      // Linkedin Accounts
      if (linkedin_accounts.length === 0) {
        newElements = {
          ...newElements,
          linkedin: {
            ...newElements.linkedin,
            done: false,
          },
        };
      } else {
        newElements = {
          ...newElements,
          linkedin: {
            ...newElements.linkedin,
            done: true,
            invalid: linkedin_accounts?.filter((x) => x.is_valid)?.length === 0,
          },
        };
      }

      // Lists
      if (lists.length === 1 || lists.length === 0 || !lists) {
        newElements = {
          ...newElements,
          contacts: {
            ...newElements.contacts,
            done: false,
          },
        };
      } else {
        newElements = {
          ...newElements,
          contacts: {
            ...newElements.contacts,
            done: true,
          },
        };
      }

      // Models
      if (model_emails?.length === 0 || !model_emails) {
        newElements = {
          ...newElements,
          models: {
            ...newElements.models,
            done: false,
          },
        };
      } else {
        newElements = {
          ...newElements,
          models: {
            ...newElements.models,
            done: true,
          },
        };
      }

      // Campaigns
      if (
        global_stats.programmation_running +
        global_stats.programmation_stopped +
        global_stats.programmation_archived ===
        0
      ) {
        newElements = {
          ...newElements,
          campaign: {
            ...newElements.campaign,
            done: false,
          },
        };
      } else {
        newElements = {
          ...newElements,
          campaign: {
            ...newElements.campaign,
            done: true,
          },
        };
      }

      setElements(newElements);
    }
  }, [
    loading,
    email_accounts.length,
    global_stats.programmation_archived,
    global_stats.programmation_running,
    global_stats.programmation_stopped,
    linkedin_accounts.length,
    lists.length,
    model_emails?.length,
    lang,
    profile?.company,
    profile?.mobile_phone,
    profile?.job_title,
    email_accounts,
    linkedin_accounts,
    lists,
    model_emails,
  ]);

  const getHeight = useCallback(() => {
    if (active === "email") {
      return 500;
    }
    if (active === "linkedin") {
      return 500;
    }
    if (active === "contacts") {
      return 490;
    }
    if (active === "models") {
      return 430;
    }
    if (active === "campaign") {
      return 480;
    }
    return 420;
  }, [active]);

  const progress = useMemo(() => {
    return (
      Object.values(elements)
        .splice(1)
        .filter((x) => x.done === true).length * (elements.profile ? 17 : 20)
    );
  }, [elements]);

  return (
    <Stack gap={0} mx={0} w={"100%"} className="get-started" mt={24}>
      <Title
        size={"xl"}
        order={4}
        fw={600}
        ff={"Inter"}
        mb={8}
        pos={"relative"}
      >
        {lang.home.get_started.title}
      </Title>
      {progress < 100 && (
        <Group mb={8} gap={"xl"}>
          <Progress
            flex={1}
            value={progress}
            size={12}
            radius={"md"}
            styles={{ section: { borderRadius: 8 } }}
          />
          <Text size="xl">{progress}%</Text>
        </Group>
      )}
      <Group
        w={"100%"}
        mt={8}
        wrap="nowrap"
        align="stretch"
        gap={0}
        pos={"relative"}
      >
        <LoadingOverlay visible={loading} />
        <Paper
          pos={"absolute"}
          top={0}
          left={0}
          w={"100%"}
          h={"100%"}
          style={{
            transition: "all ease .3s",
            borderRadius: 12,
            background: "#fff",
            boxShadow: "#00000012 0 1px 4px",
          }}
        />
        <Stack w={"50%"} className="buttons" p={"xl"} pt={50}>
          {Object.keys(elements).map((key) => {
            let item = elements[key];

            if (key === "def") {
              return "";
            }

            return (
              <Group wrap="nowrap" key={key}>
                <Locked
                  disableLock={key !== "linkedin"}
                  right={120}
                  disabledProps={{ variant: "filled" }}
                >
                  {(isLocked) => (
                    <Button
                      size="lg"
                      w={active === key ? "100%" : "95%"}
                      justify="start"
                      radius={"lg"}
                      h={64}
                      className="bump-stroke test no-shadow"
                      variant={active === key ? "light" : "default"}
                      onClick={() => {
                        setActive(active === key ? "def" : key);
                      }}
                      c={"black"}
                      leftSection={
                        item.invalid ? (
                          <ThemeIcon
                            variant="subtle"
                            color="red"
                            size={"lg"}
                            radius={"md"}
                          >
                            <IconAlertTriangle />
                          </ThemeIcon>
                        ) : item.done ? (
                          <ThemeIcon
                            variant="subtle"
                            color={"green"}
                            size={"lg"}
                            radius={"md"}
                          >
                            <IconCheckmark
                              style={{
                                width: 20,
                                height: 20,
                                fill: "var(--mantine-color-green-6)",
                              }}
                            />
                          </ThemeIcon>
                        ) : (
                          <ThemeIcon
                            variant="subtle"
                            size={"lg"}
                            radius={"md"}
                            color="secondary.6"
                          >
                            <IconLoader size={24} />
                          </ThemeIcon>
                        )
                      }
                      opacity={
                        isLocked
                          ? 0.4
                          : active === "def"
                            ? 1
                            : active === key
                              ? 1
                              : 0.7
                      }
                      rightSection={
                        <IconChevronDown
                          size={24}
                          opacity={active === key ? 1 : 0.4}
                          style={{
                            transform:
                              active === key ? "rotate(-90deg)" : "none",
                            transition: "all ease .3s",
                          }}
                        />
                      }
                      styles={{
                        label: {
                          marginLeft: 16,
                        },
                      }}
                      style={{
                        border: "1px solid #f2eaff",
                        transition: "all ease .3s",
                      }}
                      disabled={isLocked}
                    >
                      {item.label}
                    </Button>
                  )}
                </Locked>
              </Group>
            );
          })}
        </Stack>

        <Stack
          w={"50%"}
          gap={0}
          pos={"relative"}
          style={{
            transition: "all ease .3s",
            // borderRadius: 24,
            // background: "#fff",
            // boxShadow: "#00000012 0 1px 4px",
            height: getHeight(),
            overflow: "hidden",
            borderLeft: "1px solid #A570FF16",
            marginTop: 32,
            marginBottom: 32,
          }}
          align="center"
        >
          <DefaultContent active={active} setActive={setActive} />

          <ProfileContent active={active} onFinish={() => setActive("email")} />

          <EmailContent active={active} isInvalid={elements.email.invalid} />

          <LinkedinContent
            active={active}
            isInvalid={elements.linkedin.invalid}
          />

          <ContactsContent active={active} />

          <ModelsContent active={active} />

          <CampaignContent active={active} />
        </Stack>
      </Group>

      <Group wrap="nowrap" gap={48} mt={48} align="stretch" mb={32}>
        <Paper
          className="animate__animated animate__fadeInRight animate__faster"
          gap={0}
          mx={0}
          w={"50%"}
          p={"xl"}
          shadow="xs"
          wrap="nowrap"
          component={Stack}
          style={{
            borderRadius: 12,
            boxShadow: "#00000012 0 1px 4px",
          }}
        >
          <Stack w={"100%"} gap={"sm"}>
            <Text
              fw={600}
              size="xl"
              // w={700}
              style={{
                textWrap: "nowrap",
              }}
              className="agence"
              fz={19}
            >
              <span style={{ fontSize: 24, marginRight: 8 }}>🎁</span>{" "}
              {lang.home.bottom.reseller.title.replace(
                "Magileads",
                useSessionStore.getState().reseller?.name
              )}
            </Text>

            {useSessionStore.getState().reseller?.name === "Magileads" ? (
              <Text fw={400} className="dispose" fz={16}>
                {lang.home.bottom.reseller.text1}
                <b>{lang.home.bottom.reseller.text2}</b>
                {lang.home.bottom.reseller.text3} <b>API</b>{" "}
                {lang.home.bottom.reseller.text4}
              </Text>
            ) : (
              <Text fw={400} className="dispose" fz={16}>
                {lang.home.bottom.reseller.text_white_label_only}
              </Text>
            )}
          </Stack>

          <Group wrap="nowrap" gap={"xl"} mt={24} justify="start">
            {useSessionStore.getState().reseller?.name === "Magileads" && (
              <Button
                size="lg"
                radius={"md"}
                variant="light"
                fe
                leftSection={
                  <ThemeIcon size={32}>
                    <IconWhiteLabel defaultFilled="var(--mantine-color-primary-6)" />
                  </ThemeIcon>
                }
                w={230}
                component={Link}
                to={"/resellers"}
              >
                {lang.home.bottom.reseller.button1}
              </Button>
            )}

            <Button
              size="lg"
              radius={"md"}
              variant="light"
              leftSection={<KeyIcon size={24} />}
              w={230}
              filled={{ from: "#0cc0df", to: "#ffde59", deg: 90 }}
              component={Link}
              to={"/settings/integrations"}
            >
              {lang.home.bottom.reseller.api}
            </Button>
          </Group>
        </Paper>

        <Paper
          gap={0}
          mx={"auto"}
          w={"50%"}
          p={"xl"}
          pt={18}
          style={{
            borderRadius: 12,
            boxShadow: "#00000012 0 1px 4px",
          }}
        >
          <Title
            fw={600}
            size="xl"
            // w={700}
            style={{
              textWrap: "nowrap",
            }}
            className="agence"
            fz={19}
            ta={"center"}
            mt={18}
          >
            {lang.home.bottom.help.title}{" "}
            {useProfileStore.getState().profile?.first_name} ?
          </Title>

          <Stack
            gap={0}
            mx={0}
            mt={20}
            w={"100%"}
            px={0}
            style={{
              borderRadius: 24,
            }}
          >
            <Group wrap="nowrap" gap={"lg"}>
              {useSessionStore.getState().reseller?.book_demo && (
                <Button
                  radius={"md"}
                  size="lg"
                  variant="outline"
                  leftSection={<CalendarStarIcon size={32} />}
                  w={"100%"}
                  style={{
                    borderColor: "#f2eaff",
                  }}
                  component={Link}
                  to={
                    useSessionStore.getState().reseller?.name === "Magileads"
                      ? "https://www.magileads.com/reserver-votre-demo/"
                      : useSessionStore.getState().reseller?.book_demo
                  }
                  target="_blank"
                >
                  {lang.home.bottom.help.button1}
                </Button>
              )}

              {useSessionStore.getState().reseller?.contact_support && (
                <Button
                  radius={"md"}
                  size="lg"
                  variant="outline"
                  leftSection={<IconHeadset size={24} />}
                  w={"100%"}
                  style={{
                    borderColor: "#f2eaff",
                  }}
                  component={Link}
                  to={
                    useSessionStore.getState().reseller?.name === "Magileads"
                      ? "https://www.magileads.com/demo/#contact"
                      : useSessionStore.getState().reseller?.contact_support
                  }
                  target="_blank"
                >
                  {lang.home.bottom.help.button2}
                </Button>
              )}
            </Group>

            <Button
              mt={16}
              radius={"md"}
              size="lg"
              variant="outline"
              leftSection={<QuestionIcon size={32} />}
              w={"100%"}
              style={{
                borderColor: "#f2eaff",
              }}
              component={Link}
              to={"/support"}
              target="_blank"
            >
              {lang.home.bottom.help.button3}
            </Button>
          </Stack>
        </Paper>
      </Group>

      {active !== "def" &&
        !openedVideo &&
        useSessionStore.getState().reseller.name === "Magileads" && (
          <Paper
            pos={"fixed"}
            bottom={32}
            right={16}
            w={200}
            h={100}
            style={{ zIndex: 4, overflow: "hidden", cursor: "pointer" }}
            radius={8}
            shadow="lg"
            className="affix-video animate__animated animate__zoomInRight"
            // onClick={() => setOpenedVideo(true)}
            component={Link}
            to={"https://www.youtube.com/watch?v=qzZkcmTB5I0"}
            target="_blank"
          >
            <img src={lang.id === "FRA" ? cover_fr : cover_en} width={"100%"} />
          </Paper>
        )}

      {/* <Modal
        opened={openedVideo}
        size={"auto"}
        centered
        onClose={() => setOpenedVideo(false)}
        withCloseButton={false}
        radius={18}
        styles={{
          body: {
            padding: 8,
          },
        }}
      >
        <img src={mockup} width={1024} style={{ marginBottom: -6 }} />
      </Modal> */}
    </Stack>
  );
};

export default GetStarted;
